<header>
    <h1>COMPSCI 194-26: Project 1</h1>
    <h3>Images of the Russian Empire</h3>
    <h4>Kevin Mo (kevmo.xyz) // kevmo (at) bk (dot) edu</h4>
</header>

<style>
header {
    text-align: center;
    padding: 2em 0;
}

h1 {
    color: #3ac2b1;
    font-size: 2.5em;
}

h1, h3, h4 {
    margin: .5rem 0;
    padding: 0;
}

h4 {
    color: #8c8c8c;
}
</style>